import { Controller } from "@hotwired/stimulus"

// Toggles the window-days inputs depending on the chosen
// per-shift compensation_strategy. PR #05.
//
// Markup:
//   <div data-controller="compensation-strategy">
//     <select data-action="change->compensation-strategy#toggle"
//             data-compensation-strategy-target="strategy">…</select>
//     <div data-compensation-strategy-target="window" hidden>…</div>
//   </div>
export default class extends Controller {
  static targets = ["strategy", "window"]

  connect() {
    this.toggle()
  }

  toggle() {
    if (!this.hasStrategyTarget || !this.hasWindowTarget) return
    const value = this.strategyTarget.value
    const show = value === "flexible_window" || value === "fixed_days"
    this.windowTarget.hidden = !show
  }
}
